<template>
  <AlbumMissing
    v-if="album.error && album.upc"
    :upc="album.upc"
    :message="album.message"
    :provider="capitalize(provider)"
  />

  <TrackMissing
    v-else-if="album.error && album.isrc"
    :isrc="album.isrc"
    :message="album.message"
    :provider="capitalize(provider)"
  />

  <div v-else class="card">
    <div class="card-image">
      <img
        :src="album.packshot_medium_url || `https://dummyimage.com/300`"
        :alt="album.title"
      >
    </div>

    <div class="card-info">
      <div :class="!showTracks ? 'basic-info show' : 'basic-info'">
        <h3 class="card-title">{{ album.display_artist }}</h3>
        <p class="description"><strong>Title:</strong> {{ album.title }}</p>
        <p class="description"><strong>Label:</strong> {{ album.label }}</p>
        <p class="description"><strong>UPC:</strong> {{ album.upc }}</p> 
        <p class="description"><strong>Release Date:</strong> {{ album.digital_release_date }}</p>
        <p class="description"><strong>Release Number:</strong> {{ album.display_release_number }}</p>
        <p class="description"><strong>Search Provider:</strong> {{ capitalize(provider) }}</p>
      </div>

      <div :class="showTracks ? 'tracks-info show' : 'tracks-info'">
        <div class="track-headers">
          <h5>#</h5>
          <h5>Title</h5>
          <h5>Length</h5>
          <h5>ISRC</h5>
        </div>
        <AlbumTrack
          v-for="track in album.tracks"
          :key="track.isrc"
          :track="track"
        />
      </div>
    </div>

    <div class="card-actions">
      <button
        :class="showTracks ? 'track-button show' : 'track-button'"
        @click="showTracks = !showTracks"
      >
        {{ showTracks ? 'Hide' : 'Show' }} tracks
      </button>
      <button class="track-button sync" @click="syncItem()">Sync</button>
    </div>
  </div>
</template>

<script>
import AlbumMissing from '@/components/AlbumMissing'
import TrackMissing from '@/components/TrackMissing'
import AlbumTrack from '@/components/AlbumTrack'

export default {
  name: 'AlbumCard',

  components: { AlbumMissing, AlbumTrack, TrackMissing},

  props: {
    album: {
      type: Object,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showTracks: false
    }
  },

  methods: {
    capitalize(word) {
      return word.charAt(0).toUpperCase() + word.substring(1)
    },

    syncItem() {
      this.$emit('syncAlbum', {
        upc: this.album.upc,
        provider: this.provider
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card-info {
  width: 500px;
  position: relative;

  .basic-info {
    text-align: left;
    padding: 20px;
    transition: all 0.75s ease-in-out;
    transform: translate3d(0, -100%, 0);

    &.show {
      transform: translate3d(0, 0, 0);
    }
  }

  .tracks-info {
    height: calc(100% - 40px);
    padding-left: 20px;
    overflow-y: scroll;
    transition: all 0.75s ease-in-out;
    width: 100%;
    position: absolute;
    left: 0;
    top: calc(100% + 20px);

    &.show {
      top: 20px;
    }
  }
}

.card-image {
  display: flex;
  position: relative;
  width: 250px;

  img {
    max-width: 100%;
    height: auto;
  }
}

.card-actions {
  box-sizing: border-box;
  width: 150px;
  display: flex;
  flex-direction: column;
  padding: 25px;

  button {
    margin: 10px 0;
  }
}

small {
  margin-bottom: 10px;
  display: block;
}

.track-headers {
  background-color: #cccccc;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 5px 10px;

  h5 {
    width: 70px;
    text-align: left;

    &:first-child {
      width: 40px;
    }

    &:nth-child(2) {
      width: 240px;
    }

    &:last-child {
      width: 110px;
    }
  }
}

.track-button {
  font-size: 0.75em;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background-color: #42b983;
  padding: 5px 10px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #ffffff;

  &.show {
    background-color: #2c3e50;
  }

  &.sync {
    background-color: #187fe7;
  }
}
</style>
